import Vue from 'vue';
import Router from 'vue-router';

import persisted from '@/helpers/modules/auth';

import Errors404 from '@/views/Errors/404.vue';

import ProposalsRead from '@sdk/views/Proposals/Read.vue';

import SimulationsRead from '@sdk/views/Simulations/Read.vue';

import CommercialReturnsForm from '@/views/Settings/Commercial/Returns/Form.vue';

import CommercialPricesForm from '@/views/Settings/Commercial/Prices/Form.vue';

import CommercialProductsForm from '@/views/Settings/Commercial/Products/Form.vue';


import InvitationsRead from '@sdk/views/Invitations/Read.vue';

Vue.use(Router);

function scroll(to, from) {
  if (to.name === from.name) {
    return null;
  }

  const data = {
    x: 0,
    behavior: 'smooth',
  };

  if (to.hash) {
    data.selector = to.hash;
  } else {
    data.y = 0;
  }

  return data;
}

const router = new Router({
  mode: 'history',
  scrollBehavior: scroll,
  routes: [{
    // A HOME É DO WEB, e esta rota fica só para devolver o caminho a ele: o bloco
    // de aprovadas era a última tela desta pwa a montar aqui, e passou ao embed
    // hospedado pelo `web` (`web:home/_approved.html.erb`).
    path: '/',
    name: 'home',
    meta: {
      external: true,
      title: 'Início',
    },
  }, {
    path: '/customers',
    name: 'customers-list',
    meta: {
      external: true,
      title: 'Clientes',
    },
  }, {
    /*
     * AS TELAS DE CLIENTE SÃO DO EMBED, hospedadas pelo web (`web:customers/{new,edit,
     * show}.html.erb`): o formulário de PF e PJ, o cadastro de avalista e as abas de
     * visualização. As ROTAS ficam aqui, sem componente, e é `external` que as faz
     * funcionar - a flag manda o `beforeEach` devolver o caminho ao servidor, e sem ela o
     * registro casa sem componente e o `router-view` renderiza VAZIO, tela em branco
     * silenciosa. É também o que faz o atalho da barra lateral devolver o clique ao
     * navegador (`web:credere/external/pwa.js`).
     *
     * Telas que continuam aqui voltam a elas POR NOME: o "cadastrar cliente" da tela de
     * resultado (`@sdk/views/Simulations/Read.vue`) e as ações do resumo do cliente na
     * proposta (`@sdk/views/Customers/Actions.vue`). E é do `title` de cada uma que sai a
     * TRILHA das telas que sobraram, montada segmento a segmento (`App.vue`).
     *
     * A ABA DE HISTÓRICO SAIU INTEIRA: nada mais navega para ela, e caminho sem registro
     * cai no `errors-404`, de onde aquele mesmo interceptador já devolve o clique.
     */
    path: '/customers/new',
    name: 'customers-new',
    meta: {
      external: true,
      title: 'Novo',
    },
  }, {
    path: '/customers/:id/edit',
    name: 'customers-edit',
    meta: {
      external: true,
      title: 'Editar',
    },
  }, {
    path: '/customers',
    name: 'customers-read',
    meta: {
      external: true,
      title: 'Visualizar',
    },
    children: [{
      path: ':id',
      name: 'customers-read-profile',
      meta: {
        external: true,
        title: 'Visualizar',
      },
    }, {
      path: ':id/proposals',
      name: 'customers-read-proposals',
      meta: {
        external: true,
        title: 'Visualizar',
      },
    }, {
      path: ':id/guarantors',
      name: 'customers-read-guarantors',
      meta: {
        external: true,
        title: 'Visualizar',
      },
    }, {
      // O caminho que o perfil tinha, e que continua circulando. Sem nome: nada navega
      // para ele, e dois registros não podem dividir um.
      path: ':id/profile',
      meta: {
        external: true,
        title: 'Visualizar',
      },
    }],
  }, {
    path: '/proposals',
    name: 'proposals-list',
    meta: {
      external: true,
      title: 'Propostas',
    },
  }, {
    path: '/proposals/approved',
    name: 'proposals-approved',
    meta: {
      external: true,
      title: 'Aprovadas',
    },
  }, {
    /*
     * OS TRÊS FORMULÁRIOS DE PROPOSTA SÃO DO EMBED, hospedados pelo web
     * (`web:proposals/_embed_form.html.erb`, que escolhe a tela pelo `?integrated`). As
     * rotas ficam aqui, sem componente, porque telas que continuam nesta SPA voltam a elas
     * POR NOME: o formulário de cliente (nativo e o do SDK), o "alterar dados da simulação"
     * da tela de resultado e as duas de `/proposals/:id`. `external` é o que faz o
     * `beforeEach` devolver o caminho ao servidor em vez de resolvê-lo neste roteador.
     *
     * A listagem de tentativas e o detalhe de uma saíram: eram `redirect` daqui, e agora o
     * Rails redireciona sem que o navegador baixe este bundle para descobrir isso.
     */
    path: '/proposals/new',
    name: 'proposals-new',
    meta: {
      external: true,
      title: 'Nova',
    },
  }, {
    path: '/proposals/:proposal_id/proposal_attempts/new',
    name: 'proposal-attempts-new',
    meta: {
      external: true,
      title: 'Nova',
    },
  }, {
    path: '/proposals/:proposal_id/proposal_attempts/:proposal_attempt_id/edit',
    name: 'proposal-attempts-edit',
    meta: {
      external: true,
      title: 'Editar',
    },
  }, {
    path: '/proposals/:id',
    alias: '/proposals/:id/comments',
    name: 'proposals-read',
    component: ProposalsRead,
    meta: {
      title: 'Visualizar',
    },
  }, {
    path: '/simulations',
    name: 'simulations-list',
    meta: {
      external: true,
      title: 'Simulações',
    },
  }, {
    /*
     * O FORMULÁRIO DE SIMULAÇÃO É DO EMBED, hospedado pelo web
     * (`web:simulations/new.html.erb`). A rota fica aqui, sem componente, porque a tela de
     * resultado volta para ela POR NOME (o "Alterar dados da simulação" de
     * `@sdk/views/Simulations/Read.vue`), e `external` é o que faz o `beforeEach` devolver
     * o caminho ao servidor em vez de resolvê-lo neste roteador: sem a flag o registro
     * casa sem componente e o `router-view` renderiza VAZIO, tela em branco silenciosa.
     */
    path: '/simulations/new',
    name: 'simulations-new',
    meta: {
      external: true,
      title: 'Nova',
    },
  }, {
    path: '/simulations/:uuid',
    name: 'simulations-read',
    component: SimulationsRead,
    meta: {
      title: 'Resultado',
    },
  }, {
    path: '/vehicles',
    name: 'vehicles-list',
    meta: {
      external: true,
      title: 'Estoque',
    },
  }, {
    // OS TRÊS MENUS DE /settings SÃO DO EMBED, hospedados pelo web
    // (`web:settings/{index,commercial,about}.html.erb`). Ficam aqui como
    // `external` porque é o que faz o atalho da barra lateral devolver o caminho
    // ao servidor em vez de resolvê-lo neste roteador
    // (`web:credere/external/pwa.js`): sem isso, clicar em "Configurações"
    // continuaria montando a tela que este arquivo não tem mais.
    path: '/settings',
    name: 'settings-list',
    meta: {
      external: true,
      title: 'Configurações',
    },
  }, {
    path: '/settings/about',
    name: 'settings-about',
    meta: {
      external: true,
      title: 'Sobre',
    },
  }, {
    name: 'stores-public-simulator-list',
    path: '/settings/public_simulator',
    meta: {
      external: true,
      title: 'Showroom',
    },
  }, {
    path: '/settings/system_alerts',
    name: 'settings-system-alerts',
    meta: {
      external: true,
      title: 'Alertas',
    },
  }, {
    name: 'accounts-list',
    path: '/accounts',
    meta: {
      title: 'Contas',
      external: true,
    },
  }, {
    name: 'accounts-read',
    path: '/accounts/:id',
    meta: {
      title: 'Visualizar',
      external: true,
    },
  }, {
    name: 'account-stores',
    path: '/accounts/:id/stores',
    meta: {
      title: 'Lojas',
      external: true,
    },
  }, {
    name: 'users-list',
    path: '/users',
    meta: {
      title: 'Usuários',
      external: true,
    },
  }, {
    name: 'invitations-read',
    path: '/users/invitations',
    component: InvitationsRead,
    meta: {
      title: 'Convites',
    },
  }, {
    name: 'users-read',
    path: '/users/:id',
    meta: {
      title: 'Visualizar',
      external: true,
    },
  }, {
    name: 'users-edit',
    path: '/users/:id/edit',
    meta: {
      title: 'Editar',
      external: true,
    },
  }, {
    name: 'reports-home',
    path: '/report/home',
    meta: {
      title: 'Relatórios',
      external: true,
    },
  }, {
    name: 'stores-list',
    path: '/stores',
    meta: {
      title: 'Lojas',
      external: true,
    },
  }, {
    name: 'stores-read',
    path: '/stores/:id',
    meta: {
      title: 'Visualizar',
      external: true,
    },
  }, {
    /*
     * O CONTROLE COMERCIAL DE UMA LOJA. Era `/settings/commercial/*`, com as listagens
     * mostrando as regras de TODAS as lojas e dois seletores de loja próprios; veio para
     * dentro da loja porque o dado sempre foi dela - preço, comissão e ranking exigem
     * `store_id` no modelo, e as regras de retorno e produto só entram em listagem quando
     * têm loja. O caminho passou a dizer o que o dado já dizia.
     *
     * O MENU E AS TRÊS LISTAGENS SÃO DO EMBED, hospedados pelo `web`. Ficam aqui como
     * `external` pelo mesmo motivo dos três menus de `/settings`: é o que faz o atalho da
     * barra lateral devolver o caminho ao servidor em vez de resolvê-lo neste roteador
     * (`web:credere/external/pwa.js`). E é deles que sai a TRILHA das páginas abaixo, que
     * esta pwa monta resolvendo cada SEGMENTO do caminho atual (`App.vue`) - sem a rota do
     * prefixo, o nível some da trilha.
     *
     * O QUE FICA AQUI SÃO OS FORMULÁRIOS, que ainda não têm par no embed.
     */
    path: '/stores/:id/commercial_control',
    name: 'stores-commercial-control',
    meta: {
      external: true,
      title: 'Controle comercial',
    },
  }, {
    path: '/stores/:id/commercial_control/returns',
    name: 'stores-commercial-control-returns',
    meta: {
      external: true,
      title: 'Retornos',
    },
  }, {
    path: '/stores/:id/commercial_control/returns/new',
    name: 'stores-commercial-control-returns-new',
    component: CommercialReturnsForm,
    meta: {
      title: 'Nova regra',
    },
  }, {
    // A LOJA JÁ OCUPA O `:id` DO CAMINHO, então a regra entra com nome próprio - como em
    // `proposal_attempts/:proposal_attempt_id/edit` e nas automações do showroom.
    path: '/stores/:id/commercial_control/returns/:rule_id',
    name: 'stores-commercial-control-returns-update',
    component: CommercialReturnsForm,
    meta: {
      title: 'Editar regra',
    },
  }, {
    path: '/stores/:id/commercial_control/prices',
    name: 'stores-commercial-control-prices',
    meta: {
      external: true,
      title: 'Preços',
    },
  }, {
    path: '/stores/:id/commercial_control/prices/new',
    name: 'stores-commercial-control-prices-new',
    component: CommercialPricesForm,
    meta: {
      title: 'Nova regra',
    },
  }, {
    path: '/stores/:id/commercial_control/prices/:rule_id',
    name: 'stores-commercial-control-prices-update',
    component: CommercialPricesForm,
    meta: {
      title: 'Editar regra',
    },
  }, {
    path: '/stores/:id/commercial_control/products',
    name: 'stores-commercial-control-products',
    meta: {
      external: true,
      title: 'Produtos',
    },
  }, {
    path: '/stores/:id/commercial_control/products/new',
    name: 'stores-commercial-control-products-new',
    component: CommercialProductsForm,
    meta: {
      title: 'Nova regra',
    },
  }, {
    path: '/stores/:id/commercial_control/products/:rule_id',
    name: 'stores-commercial-control-products-update',
    component: CommercialProductsForm,
    meta: {
      title: 'Editar regra',
    },
  }, {
    // Os dois TIPOS de comissão da loja (SPF e Plus), um menu do embed - e o formulário de
    // cada tipo também é, hospedado pelo web.
    path: '/stores/:id/commercial_control/commissions',
    name: 'stores-commercial-control-commissions',
    meta: {
      external: true,
      title: 'Comissões',
    },
  }, {
    /*
     * A ÁREA DO SHOWROOM DA LOJA: o menu de opções e, sob ele, uma tela por opção - todas
     * do embed, hospedadas pelo web. Os caminhos são os mesmos que ele serve (wip#1342).
     *
     * ESTA ROTA FICA SEM COMPONENTE, e é `external` que a faz funcionar: a flag manda o
     * `beforeEach` devolver o caminho ao servidor (`window.location.href`) em vez de
     * resolvê-lo neste roteador. Sem ela o caminho NÃO cai no `path: '*'` - o registro
     * existe e casa, só não tem componente -, então o `router-view` renderiza VAZIO: tela
     * em branco silenciosa, que é pior que um 404.
     *
     * Ela existe pelo atalho da barra lateral (`web:credere/external/pwa.js`), que resolve
     * o caminho aqui antes de decidir se sequestra o clique.
     */
    name: 'stores-public-simulator',
    path: '/stores/:id/public_simulator',
    meta: {
      external: true,
      title: 'Showroom',
    },
  }, {
    name: 'settings-public-simulator-automations',
    path: '/settings/public_simulator/automations',
    meta: {
      external: true,
      title: 'Automação de mensagens',
    },
  }, {
    name: 'settings-public-simulator-notifications',
    path: '/settings/public_simulator/notifications',
    meta: {
      external: true,
      title: 'Notificações de vendedores',
    },
  }, {
    // O CATÁLOGO de perguntas frequentes: outra tela e outro público que as respostas da
    // loja - é a Eita que cadastra e remove pergunta, sem deploy. Os caminhos são os
    // mesmos que o web hospeda (wip#1381).
    name: 'settings-public-simulator-questions',
    path: '/settings/public_simulator/questions',
    meta: {
      external: true,
      title: 'Perguntas frequentes (catálogo)',
    },
  }, {
    path: '*',
    name: 'errors-404',
    component: Errors404,
    meta: {
      title: 'Oops!',
      unauthenticated: true,
    },
  }],
});

router.beforeEach((to, from, next) => {
  const { meta } = to;

  if (/^http(s?):\/\//.test(to.path)) {
    window.open(to.path, '_blank');

    return next(false);
  }

  // Rota `external` é servida por fora: ao navegador vai o endereço INTEIRO, com a query.
  if (meta && meta.external) {
    window.location.href = to.fullPath;

    return next(false);
  }

  if ((!meta || !meta.unauthenticated) && (!persisted.token || !persisted.user)) {
    return next({ name: 'errors-404' });
  }

  return next();
});

router.afterEach(() => {
  if (!window.gtag) {
    return;
  }

  if (window.gtag.CREDERE_PWA_RENDERED) {
    window.gtag('event', 'page_view');
  } else {
    window.gtag.CREDERE_PWA_RENDERED = true;
  }
});

export default router;
